import { render, staticRenderFns } from "./Paginations.vue?vue&type=template&id=50a14756&"
import script from "./Paginations.vue?vue&type=script&lang=js&"
export * from "./Paginations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50a14756')) {
      api.createRecord('50a14756', component.options)
    } else {
      api.reload('50a14756', component.options)
    }
    module.hot.accept("./Paginations.vue?vue&type=template&id=50a14756&", function () {
      api.rerender('50a14756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/Paginations.vue"
export default component.exports